import styles from './RouteProgressBar.module.css'

export type TRouteProgressPhase = 'idle' | 'loading' | 'done'

type TRouteProgressBarProps = {
    phase: TRouteProgressPhase
}

export const RouteProgressBar = ({ phase }: TRouteProgressBarProps) => {
    if (phase === 'idle') {
        return null
    }

    return (
        <div aria-hidden="true" data-phase={phase} className={styles.root}>
            <div className={styles.bar} />
        </div>
    )
}
